import {Options} from "../../../../../../../../../../form/options/options";
import avatar from "../../../../../../../../../../../assets/uploads/student-avatar.jpg";
import avatar2 from "../../../../../../../../../../../assets/uploads/teacher-avatar.jpg";

export interface Option {
    name: string;
    value: string;
}


export interface OptionsAva {
    value: string,
    label: string,
    avatar: string
}


export const optionsStatus: Options[] = [
    {value: 'done', label: 'Выполнено'},
    {value: 'notDone', label: 'Не выполнено'},
    {value: 'partiallyDone', label: 'Частично выполнено'},
    {value: 'notVerified', label: 'Не проверено'},
    // {value: 'notAssigned', label: 'Не сдано'},
];

export const courseTitle: Options[] = [
    {value: 'курс для начинающих – Английский с нуля', label: 'Курс для начинающих – Английский с нуля'},
    {value: 'не курс для начинающих – Английский с нуля', label: 'Не курс для начинающих – Английский с нуля'},
];


export const country: Options[] = [
    {value: 'беларусь', label: 'Беларусь'},
    {value: 'беларусь', label: 'Беларусь'},
    {value: 'беларусь', label: 'Беларусь'},
];

export const optionsGroups: Options[] = [
    {value: 'Все группы1', label: 'Все группы'},
    {value: 'Все группы2', label: 'Все группы'},
    {value: 'Все группы3', label: 'Все группы'},
];

export const optionsStudentsAvatar: OptionsAva[] = [
    {
        value: 'one',
        label: 'Анастасия Соболевская',
        avatar: '../../../../../../../../../../../assets/uploads/student-avatar.jpg'
    },
    {
        value: 'two',
        label: 'Александр Иванов',
        avatar: '../../../../../../../../../../../assets/uploads/teacher-avatar.jpg'
    },
    {
        value: 'three',
        label: 'Петр Петров',
        avatar: '../../../../../../../../../../../assets/uploads/student-avatar.jpg'
    },
    {
        value: 'four',
        label: 'Федор Федоров',
        avatar: '../../../../../../../../../../../assets/uploads/teacher-avatar.jpg'
    },
];
